import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { FormMode } from 'src/app/controls/common/form-mode';
import { Customer } from 'src/app/models/customer';
import { CustomersService } from 'src/app/services/customers.service';

@Component({
    selector: 'app-customer-alias-dialog',
    templateUrl: './customer-alias-dialog.component.html',
    styleUrls: ['./customer-alias-dialog.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatOptionModule, MatButtonModule, NgClass, MatDialogClose]
})
export class CustomerAliasDialogComponent implements OnInit {
    public FormMode = FormMode;

    /**
     * Champs du formulaire de saisie du nom.
     */
    public aliasFormControl = new UntypedFormControl(null, Validators.required);
    public customerFormControl = new UntypedFormControl(null, Validators.required);
    public idFormControl = new UntypedFormControl(null);

    // public reminderActionDatasFormControl = new FormControl(null, Validators.required);

    public get isValid(): boolean {
        return this.aliasFormControl.valid && this.customerFormControl.valid;
    }

    customers: Customer[];

    public title = "Ajout d'un alias";

    constructor(
        public dialogRef: MatDialogRef<CustomerAliasDialogComponent>,
        public customersService: CustomersService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit(): void {
        this.loadCustomers();

        this.idFormControl.disable();

        if (this.data.mode === FormMode.Reading) {
            this.aliasFormControl.disable();
            this.customerFormControl.disable();
        }

        if (this.data.mode === FormMode.Creation) {
            this.title = "Ajout d'un alias";
        } else if (this.data.mode === FormMode.Edition) {
            this.title = `Édition de l'alias ${this.data.record.id}`;
        }
        if (this.data.mode === FormMode.Reading) {
            this.title = `Alias  ${this.data.record.id}`;
        }
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public validate(): void {
        if (this.isValid) {
            this.dialogRef.close(this.data.record);
        }
    }

    loadCustomers() {
        let context: Context = {
            property: 'articleId',
            value: this.data.articleId,
        };

        this.customersService.List(context, null, null, null).subscribe((x) => {
            this.customers = x.value;
        });
    }
}
